import { EnumOption } from './enum-option';
import { createEnumOptions } from '../../shared/utils';

export enum MatterDocRequestStatus {
    "Pending" = 0,
    "Completed" = 1
}

export const MatterDocRequestStatusList: EnumOption[] = createEnumOptions(MatterDocRequestStatus);